import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/admin/health-check")({
    beforeLoad: () => {
        throw redirect({ to: "/developer/health-check", replace: true });
    },
});
